/**
 * Editorial mast — shared header for all logged-in screens.
 */
import { Link, NavLink } from "react-router-dom";
import { useAuth } from "../lib/auth.js";

export function Mast({ section }: { section?: string }) {
  const { user, logout } = useAuth();

  // 2026-05-09: dropped the standalone "Sessions" NavLink — there is no
  // /dashboard/sessions index route (only /dashboard/sessions/:id detail).
  // Trainers reach session detail through the case roster + each case's
  // session list on /dashboard. The bare nav link 404'd.
  const trainerNav = (
    <>
      <NavLink to="/dashboard" className={({isActive}) => isActive ? "active" : ""}>Cases</NavLink>
    </>
  );
  const adminNav = (
    <>
      <NavLink to="/admin/approvals" className={({isActive}) => isActive ? "active" : ""}>Approvals</NavLink>
      <NavLink to="/admin/users"     className={({isActive}) => isActive ? "active" : ""}>Users</NavLink>
    </>
  );
  const caseNav = (
    <>
      <NavLink to="/me"          className={({isActive}) => isActive ? "active" : ""}>我的訓練</NavLink>
    </>
  );

  return (
    <header className="mast">
      <div className="mast__brand">
        <Link to={user?.role === "case" ? "/me" : user?.role === "admin" ? "/admin/approvals" : "/dashboard"}
              style={{ border: "none", color: "var(--ink)" }}>
          CogniHome
        </Link>
        <span className="slash">/</span>
        <span style={{ color: "var(--ink-soft)" }}>{section ?? roleLabel(user?.role)}</span>
      </div>
      <nav className="mast__nav">
        {user?.role === "trainer" && trainerNav}
        {user?.role === "admin"   && adminNav}
        {user?.role === "case"    && caseNav}
        <span style={{ color: "var(--ink-ghost)" }}>·</span>
        <span className="muted" style={{ fontSize: "var(--t-sm)" }}>
          {user?.display_name ?? user?.email}
        </span>
        <button
          onClick={logout}
          style={{
            background: "transparent", border: "none", cursor: "pointer",
            font: "inherit", fontSize: "var(--t-sm)", color: "var(--ink-soft)",
            padding: 0,
          }}
        >Sign out</button>
      </nav>
    </header>
  );
}

function roleLabel(role?: string): string {
  switch (role) {
    case "admin":   return "Admin";
    case "trainer": return "Trainer";
    case "case":    return "個案";
    default:        return "";
  }
}
